import { render } from "./EntityDetailPanel.vue?vue&type=template&id=2bfbd0b6&scoped=true"
import script from "./EntityDetailPanel.vue?vue&type=script&lang=js"
export * from "./EntityDetailPanel.vue?vue&type=script&lang=js"

import "./EntityDetailPanel.vue?vue&type=style&index=0&id=2bfbd0b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bfbd0b6"]])

export default __exports__